import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import { PROJECT_ROOT_QUERY, PROJECT_TREE_QUERY } from './graphql'
import { FormGroup, Input, Label } from 'reactstrap'

class ProjectTreeNode extends Component {
  constructor(props) {
    super(props)
    this.state = { expanded: props.isRoot || false }
  }

  static propTypes = {
    element: PropTypes.object.isRequired,
    onCheck: PropTypes.func.isRequired,
    selectedElements: PropTypes.array.isRequired,
    children: PropTypes.array,
    isRoot: PropTypes.bool
  }

  handleToggle = () => this.setState({ expanded: !this.state.expanded })

  handleCheckChange = (e) => {
    this.props.onCheck(this.props.element, this.props.children, e.target.checked)
  }

  render() {
    const { element, children, selectedElements } = this.props
    const { expanded } = this.state
    const hasChildren = children && children.length > 0
    const displayName = element.label || element.name
    const checked = selectedElements.includes(element.id)

    return (
      <div style={{ marginLeft: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
          {hasChildren && (
            <button
              type="button"
              onClick={this.handleToggle}
              style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '5px', fontSize: '12px' }}
            >
              {expanded ? '\u25BC' : '\u25B6'}
            </button>
          )}
          <FormGroup check style={{ margin: 0 }}>
            <Label check>
              <Input type="checkbox" checked={checked} onChange={this.handleCheckChange} />
              <strong>{displayName}</strong> (ID: {element.id})
            </Label>
          </FormGroup>
        </div>
        {hasChildren && expanded && (
          <div>
            {children.map(child => (
              <ProjectTreeNode
                key={child.id}
                element={child}
                onCheck={this.props.onCheck}
                selectedElements={selectedElements}
                children={child.children}
              />
            ))}
          </div>
        )}
      </div>
    )
  }
}

class Step1ElementSelection extends Component {
  static propTypes = {
    projectId: PropTypes.number.isRequired,
    selectedElements: PropTypes.array.isRequired,
    onSelectionChange: PropTypes.func.isRequired
  }

  treeStructure = null

  getAllDescendantIds = (element, children) => {
    let ids = [element.id]
    if (children && children.length > 0) {
      children.forEach(child => {
        ids = ids.concat(this.getAllDescendantIds(child, child.children))
      })
    }
    return ids
  }

  // Build parent map: childId -> parentId
  buildParentMap = (nodes, parentId = null, map = {}) => {
    nodes.forEach(node => {
      if (parentId !== null) map[node.id] = parentId
      if (node.children && node.children.length > 0) {
        this.buildParentMap(node.children, node.id, map)
      }
    })
    return map
  }

  handleCheck = (element, children, checked) => {
    const { selectedElements, onSelectionChange } = this.props
    let newSelected = [...selectedElements]
    const descendantIds = this.getAllDescendantIds(element, children)

    if (checked) {
      // Add element + all descendants
      descendantIds.forEach(id => {
        if (!newSelected.includes(id)) newSelected.push(id)
      })
      // Also check ancestors up if all their children are now selected
      if (this.treeStructure) {
        const parentMap = this.buildParentMap(this.treeStructure)
        let parentId = parentMap[element.id]
        while (parentId !== undefined) {
          const parentNode = this.findNode(this.treeStructure, parentId)
          if (parentNode && parentNode.children) {
            const allChildrenSelected = parentNode.children.every(child => newSelected.includes(child.id))
            if (allChildrenSelected) {
              if (!newSelected.includes(parentId)) newSelected.push(parentId)
              parentId = parentMap[parentId]
            } else {
              break
            }
          } else {
            break
          }
        }
      }
    } else {
      // Remove element + all descendants
      newSelected = newSelected.filter(id => !descendantIds.includes(id))
      // Remove all ancestors (parent is no longer fully selected)
      if (this.treeStructure) {
        const parentMap = this.buildParentMap(this.treeStructure)
        let parentId = parentMap[element.id]
        while (parentId !== undefined) {
          newSelected = newSelected.filter(id => id !== parentId)
          parentId = parentMap[parentId]
        }
      }
    }

    onSelectionChange(newSelected)
  }

  findNode = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) return node
      if (node.children) {
        const found = this.findNode(node.children, id)
        if (found) return found
      }
    }
    return null
  }

  render() {
    return (
      <Query query={PROJECT_ROOT_QUERY} variables={{ id: this.props.projectId.toString() }}>
        {({ data: rootData, loading: rootLoading, error: rootError }) => {
          if (rootLoading) return <div>Loading project...</div>
          if (rootError) return <div>Error loading project</div>
          if (!rootData || !rootData.element) return <div>No project found</div>

          return (
            <Query query={PROJECT_TREE_QUERY} variables={{ project_id: this.props.projectId.toString() }}>
              {({ data: treeData, loading: treeLoading, error: treeError }) => {
                if (treeLoading) return <div>Loading project structure...</div>
                if (treeError) return <div>Error loading project structure</div>
                if (!treeData || !treeData.project_tree) return <div>No project tree found</div>

                let treeElements
                try {
                  treeElements = JSON.parse(treeData.project_tree)
                } catch (e) {
                  return <div>Error parsing project tree data</div>
                }

                this.treeStructure = [{ ...rootData.element, children: treeElements }]

                return (
                  <div>
                    <h6>Select project elements for the report:</h6>
                    <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                      {this.treeStructure.map(element => (
                        <ProjectTreeNode
                          key={element.id}
                          element={element}
                          selectedElements={this.props.selectedElements}
                          onCheck={this.handleCheck}
                          children={element.children}
                          isRoot={true}
                        />
                      ))}
                    </div>
                  </div>
                )
              }}
            </Query>
          )
        }}
      </Query>
    )
  }
}

export default Step1ElementSelection


// WEBPACK FOOTER //
// ./src/components/FinalReport/Step1ElementSelection.js